// Icons
import { BsHouseFill } from "react-icons/bs";

// Types
import type { IIdealHouseProps } from "./types";

export function IdealHouse({infocusID, OPTIONS,REP_BUILD_DATA,REP_PROJECT}: IIdealHouseProps) {

    return ( <div data-infocusID={infocusID === 11}
            className="md:absolute
                print:!relative
                print:!left-0
                border-[1px] border-r-[#000]
                last-of-type:border-none
                opacity-100 -left-[100%]
                data-[inFocusID=true]:opacity-0
                data-[inFocusID=true]:left-0
                transition-all duration-[0.38s]
                w-full h-screen flex flex-col justify-between gap-4 p-8 bg-white
                page-break
            "
        >
            <div className="w-full flex-1 flex flex-row flex-nowrap overflow-x-auto pb-4 gap-4">
                <div className="flex-1 min-w-[15%] flex flex-col gap-4 bg-slate-100 border border-gray-200 rounded-md">
                    <span className="w-full flex flex-row items-center gap-4 p-3 bg-gray-200">
                        <BsHouseFill  size={22} />
                        <span className="font-semibold text-xl">Casa Ideal</span>
                    </span>
                    <span className="w-full z-[999] px-3 flex flex-col items-start justify-start gap-2
                            [&_span]:w-full
                            [&_span]:flex
                            [&_span]:flex-row
                            [&_span]:flex-nowrap
                            [&_span]:items-center
                            [&_span]:justify-between
                            [&_span]:flex-1
                        "
                    >
                        <span>
                            <span title="Valor de venda" className="cursor-default select-none"> VGV </span>
                            <span className="font-semibold">
                                {
                                    Intl.NumberFormat('pt-BR', {
                                        style: 'currency',
                                        currency: 'BRL'
                                    }).format(REP_BUILD_DATA?.houseAmount || 0)
                                }
                            </span>
                        </span>
                        <span>
                            <span title="Área do Terreno" className="cursor-default select-none"> AT </span>
                            <span className="font-semibold !justify-end"> {REP_BUILD_DATA?.idealArea}m²</span>
                        </span>
                        <span>
                            <span title="Área Construida" className="cursor-default select-none"> AC </span>
                            <span className="font-semibold !justify-end"> {REP_BUILD_DATA?.idealAreaBuild}m²</span>
                        </span>
                    </span>
                    <span className="w-full flex-1 flex flex-col gap-2">
                        {
                            // @ts-ignore
                            OPTIONS.map((hOption, hIndex) => {
                                return <span key={hIndex}
                                    className="w-full h-[2.187rem]
                                        odd:bg-gray-200 text-[0.90rem]
                                        font-medium text-black
                                        flex flex-row flex-nowrap items-center
                                        justify-start pl-[25%] group-last/lastItem:rounded-r-[1rem]"
                                >
                                    {hOption.option}
                                </span>
                            })
                        }
                    </span>
                </div>
                {
                    REP_PROJECT && REP_PROJECT?.houses?.map((house, index) => (
                        <div key={index} className="flex-1 min-w-[15%] flex flex-col gap-4">
                            <span className="w-full flex flex-row items-center gap-2 font-semibold text-2xl">
                                <span className="w-full flex flex-row items-center gap-4 px-3 py-2 rounded-md bg-gray-200">
                                    <span className="font-semibold text-sm">
                                        {house.name}
                                    </span>
                                </span>
                            </span>
                            <span className="w-full h-24 bg-gray-200 flex flex-row items-center justify-center overflow-hidden rounded-md">
                                <img
                                    data-show={house.photo_upload_id && true}
                                    className="hidden data-[show=true]:flex"
                                    src={`${process.env.REACT_APP_API_URL}/builders/real-estate-products/houses/${house.id}/photo`}
                                />

                                <BsHouseFill
                                    data-show={!house.photo_upload_id && true}
                                    className="hidden data-[show=true]:flex"
                                    size={22}
                                />
                            </span>

                            <span className="w-full z-[999] px-3 flex flex-col items-start justify-start gap-2
                                    [&_span]:w-full
                                    [&_span]:flex
                                    [&_span]:flex-row
                                    [&_span]:flex-nowrap
                                    [&_span]:items-center
                                    [&_span]:justify-between
                                    [&_span]:flex-1
                                "
                            >
                                <span>
                                    <span title="Valor de venda" className="cursor-default select-none"> VGV </span>
                                    <span className="font-semibold">
                                        {
                                            Intl.NumberFormat('pt-BR', {
                                                style: 'currency',
                                                currency: 'BRL'
                                            }).format(REP_BUILD_DATA?.houseAmount || 0)
                                        }
                                    </span>
                                </span>
                                <span>
                                    <span title="Área do Terreno" className="cursor-default select-none"> AT </span>
                                    <span className="font-semibold !justify-end"> {REP_BUILD_DATA?.idealArea}m²</span>
                                </span>
                                <span>
                                    <span title="Área Construida" className="cursor-default select-none"> AC </span>
                                    <span className="font-semibold !justify-end"> {REP_BUILD_DATA?.idealAreaBuild}m²</span>
                                </span>
                            </span>

                            <span className="w-full flex-1 flex flex-col gap-2">
                                {
                                    // @ts-ignore
                                    OPTIONS.map((hOption, hIndex) => {
                                        const houseAlreadyOption = house?.home_options?.find((cOption) => cOption.option === hOption.option && cOption.id === hOption.id)

                                        if (houseAlreadyOption) return (
                                            // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
                                            <span key={hIndex}
                                                className="w-full h-[2.187rem] odd:bg-[#F1F3F2] text-[0.90rem] font-medium text-[#707070] flex flex-row flex-nowrap items-center justify-start pl-[25%] group-last/lastItem:rounded-r-[1rem]"
                                            >
                                                {hOption.option}
                                            </span>
                                        )
                                    })
                                }
                            </span>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}
